import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Form as NewForm } from './new_form'
import { ProductSpecificationAttributes } from '@/types'

interface Props extends BaseProps {
  defaultValues: Partial<ProductSpecificationAttributes>
}

export const NewDialog = ({ open, setOpen, defaultValues }: Props) => {
  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle>New product specification</DialogTitle>
        <DialogBody>
          <NewForm defaultValues={defaultValues} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
